const UPDATE_CURATION_PROGRESS = (state, payload) => {
  const { curationApprovals, canBeApproved } =
    payload.mainItemUpdateCurationApproval;
  state.submissionItem.curationApprovals = curationApprovals;
  state.submissionItem.canBeApproved = canBeApproved;
};

export default UPDATE_CURATION_PROGRESS;
